<template>
  <div class="forum">
    <div class="bread">
      <router-link
        :to="{ name: fromRoute.name, query: { tab: fromRoute.tab } }"
      >
        {{ fromRoute.label }}
      </router-link>
      <span class="slash">/</span>
      <span class="current">帖子详情</span>
    </div>
    <div class="title-box">
      <h4 class="title vmiddle">
        <span class="tag-top" v-if="info.is_top">置顶</span>
        <span class="tag-fine" v-if="info.is_fine">精</span>
        <span class="title-text">{{ info.main ? info.main.title : "" }}</span>
      </h4>
      <div class="other">
        <p class="time">
          <span v-if="info.created_at">
            {{ info.created_at.replace(/-/g, "/") }}
          </span>
        </p>
        <div class="set-box">
          <p class="zan">
            <span>{{ info.like_num }}</span>
          </p>
          <p class="comment">
            <span>{{ info.comment_num }}</span>
          </p>
          <p class="browse">
            <span>{{ info.click_num }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="forum-box">
      <div class="left">
        <div class="message-box">
          <div id="message" class="message" v-html="info.content"></div>
          <div class="set-box">
            <div @click="toComment" class="item icon-comment"></div>
            <div
              class="item icon-zan"
              :class="info.is_liked ? 'active' : ''"
              @click="zan"
            ></div>
            <div
              @click="collect"
              :class="info.is_collected ? 'active' : ''"
              class="item icon-collect"
            ></div>
          </div>
        </div>
        <div class="comment-box">
          <p class="comment-title">
            <span>全部评论（{{ totalPage }}）</span>
          </p>
          <div class="comment">
            <img :src="user.avatar" v-if="user" />
            <div class="content">
              <textarea
                ref="content"
                placeholder="请输入内容"
                v-model="content"
              ></textarea>
              <button
                @click="postComment()"
                class="comment-submit"
                type="button"
              >
                评论
              </button>
            </div>
          </div>
          <ul>
            <li v-for="(item, index) in comment" :key="item.id">
              <div class="user">
                <img :src="item.avatar" />
                <p class="nick">{{ item.nickname }}</p>
              </div>
              <p style="margin-top: 20px" v-html="item.content"></p>
              <p class="message">
                <template v-if="item.reply">
                  回复
                  <span class="name">@{{ item.nickname }}</span>
                </template>
                <span v-if="item.reply" v-html="item.reply.content"></span>
              </p>
              <div class="operate-wrap">
                <p class="time">{{ item.created_at.replace(/-/g, "/") }}</p>
                <span class="operate">
                  <a
                    class="lnk-delete"
                    v-if="item.user_id == $store.state.user_info.id"
                    @click="onCommentDelete(item)"
                  >
                    删除
                  </a>
                  <a class="lnk-complaint" v-else @click="onComplaint(item)">
                    举报
                  </a>
                  <span class="line">|</span>
                  <a
                    @click="checkReply(index)"
                    :class="item.replyShow ? 'active' : ''"
                  >
                    回复
                  </a>
                </span>
              </div>
              <div v-if="item.replyShow" class="reply-content">
                <textarea
                  :placeholder="'回复 @' + item.nickname"
                  v-model="replyContent"
                ></textarea>
                <button
                  @click="postComment(item.id)"
                  class="comment-submit"
                  type="button"
                >
                  发布
                </button>
              </div>
            </li>
          </ul>
          <Empty v-if="comment.length == 0" class="empty" title="暂无评论！" />
          <el-pagination
            v-if="comment.length > 0"
            background
            layout="total,prev, pager, next"
            @current-change="handle_current_change"
            :total="totalPage"
          ></el-pagination>
        </div>
      </div>
      <div class="right">
        <div class="mine m-recommend">
          <p class="title">推荐帖子</p>
          <div class="list">
            <router-link
              v-for="(item, index) in recommend"
              :key="item.id"
              :to="{
                name: 'CommunityShow',
                params: { id: item.id },
                query: { group_id: item.group_id },
              }"
            >
              {{ index + 1 }}、{{ item.main.title }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <ImageViewer :isShow.sync="showImageViewer" :images="image"></ImageViewer>
    <Complaint ref="complaint"></Complaint>
  </div>
</template>

<script>
import ImageViewer from "../ImageViewer.vue";
import Complaint from "./components/Complaint.vue";
export default {
  name: "CommunityShow",
  components: { ImageViewer, Complaint },
  data() {
    return {
      fromRoute: {
        name: this.$route.query.routeName || "Community",
        label: this.$route.query.routeLabel || "圈子",
        tab: this.$route.query.tab || null,
      },
      showImageViewer: false,
      imgBox: [], // 图片
      current: 0, // 当前图片下标
      info: {}, //话题信息
      recommend: [], //话题推荐
      comment: [], // 评论列表
      content: "", // 评论内容
      replyContent: "", // 回复内容
      totalPage: 0, //总评论数
      page: 1, //评论分页
      limit: 10, //评论数量限制
    };
  },
  created() {
    this.getPostInfo();
    this.getComment();
    this.getRecommendInfo();
  },
  mounted: function () {
    const that = this;
    this.$nextTick(() => {
      window.$("#message").on("click", "img", ev => {
        that.current = parseInt(ev.currentTarget.attributes.index.value) - 1;
        that.showImageViewer = true;
      });
    });
  },
  watch: {
    $route() {
      this.getPostInfo();
      this.getComment();
      this.getRecommendInfo();
    },
  },
  computed: {
    user() {
      return this.$store.state.user_info;
    },
    image() {
      if (this.imgBox.length) {
        let arr = [];
        arr.push(this.imgBox[this.current]);
        return arr;
      } else {
        return [];
      }
    },
  },
  methods: {
    //that.$route.query.group_id 小组Id
    //that.$route.query.id 帖子id
    //that.$route.query.plate_id 版块id  query和params数据一样
    // 获取帖子详情
    async getPostInfo() {
      const that = this;
      let data = await that.$http.get(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/post/` +
          that.$route.params.id,
        {
          group_id: that.$route.query.group_id,
          id: that.$route.params.id,
        },
      );
      let count = 0;
      data.content = data.main.content.replace(
        /<img [^>]*src=['"]([^'"]+)[^>]*>/g,
        function (match, capture) {
          that.imgBox.push(capture);
          count++;
          return (
            match.substring(0, 4) +
            ' index="' +
            count +
            '"' +
            match.substring(4)
          );
        },
      );
      that.info = data;
    },

    // 获取推荐帖子
    async getRecommendInfo() {
      const that = this;
      let data = await that.$http.get(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/post/`,
        {
          group_id: that.$route.query.group_id, //圈子
          plate_id: that.$route.query.plate_id, //版块
          limit: 10,
        },
      );
      that.recommend = data.data.map(item => ({
        ...item,
        main: {
          title: item.title,
        },
      }));
    },

    //获取评论列表
    async getComment() {
      const that = this;
      let data = await that.$http.get(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/comment`,
        {
          post_id: that.$route.params.id,
          page: that.page,
          limit: that.limit,
        },
      );
      let arr = data.data;
      for (let i = 0; i < arr.length; i++) {
        arr[i].replyShow = false;
        arr[i].content = arr[i].content.replace(/\n/g, "<br/>");
      }
      that.comment = arr;
      that.totalPage = data.total;
    },

    //分页加载评论
    handle_current_change(val) {
      this.page = val;
      this.getComment();
    },

    // 选择回复
    checkReply(index) {
      if (this.comment[index].replyShow) {
        for (let i = 0; i < this.comment.length; i++) {
          this.comment[i].replyShow = false;
        }
      } else {
        for (let i = 0; i < this.comment.length; i++) {
          this.comment[i].replyShow = false;
        }
        this.comment[index].replyShow = true;
      }
    },

    // 去评论
    toComment() {
      this.$nextTick(function () {
        this.$refs.content.focus();
      });
    },

    //点赞
    async zan() {
      const that = this;
      if (that.$store.state.token) {
        await that.$http.post(
          `/api/${this.$identity.getCommunityClientApiLetter()}/community/post/like`,
          {
            post_id: that.$route.params.id,
          },
        );
        that.$message({
          message: that.info.is_liked == 0 ? "点赞成功！" : "取消点赞成功！",
          type: "success",
        });
        if (that.info.is_liked) {
          that.info.like_num--;
          that.info.is_liked = 0;
        } else {
          that.info.like_num++;
          that.info.is_liked = 1;
        }
      } else {
        that.$router.push({
          name: "Login",
        });
      }
    },

    //收藏课程
    async collect() {
      const that = this;
      if (that.$store.state.token) {
        if (that.info.is_collected) {
          await that.$http.put(
            //取消收藏
            `/api/${this.$identity.getCommunityClientApiLetter()}/community/collect/` +
              that.info.is_collected,
          );
        } else {
          //收藏
          await that.$http.post(
            `/api/${this.$identity.getCommunityClientApiLetter()}/community/collect`,
            {
              post_id: that.$route.params.id,
            },
          );
        }
        that.$message({
          message:
            that.info.is_collected == 0 ? "收藏成功！" : "取消收藏成功！",
          type: "success",
        });
        if (that.info.is_collected) {
          that.info.is_collected = 0;
        } else {
          that.info.is_collected = 1;
        }
      } else {
        that.$router.push({
          name: "Login",
        });
      }
    },

    //发表评论
    async postComment(id) {
      const that = this;
      if (that.$store.state.token) {
        if (id) {
          if (that.replyContent == "") {
            that.$message({
              message: "回复内容不能为空！",
              type: "warning",
            });
            return;
          }
        } else if (that.content == "") {
          that.$message({
            message: "评论内容不能为空！",
            type: "warning",
          });
          return;
        }
        await that.$http.post(
          `/api/${this.$identity.getCommunityClientApiLetter()}/community/comment`,
          {
            post_id: that.$route.params.id,
            reply_id: id ? id : "",
            content: id ? that.replyContent : that.content,
          },
        );
        that.$message({
          message: "评论成功！",
          type: "success",
        });
        that.info.comment_num++;
        that.content = "";
        that.replyContent = "";
        that.postType = 0;
        that.page = 1;
        that.getComment();
      } else {
        that
          .$confirm("您还未登录，是否登录?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            that.$router.push({
              name: "Login",
            });
          })
          .catch(() => {});
      }
    },
    async onCommentDelete(item) {
      await this.$promiseConfirm("删除后，该内容将不再展示，是否确认？", {
        type: "warning",
        customClass: "confirm-common",
      });
      await this.$http.delete(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/comment/` +
          item.id,
      );
      this.info.comment_num--;
      await this.getComment();
    },
    onComplaint(item) {
      this.$refs.complaint.show(5, item.id);
    },
  },
};
</script>
<style lang="scss" scoped>
.forum {
  padding-bottom: 60px;
  overflow: hidden;
  .bread {
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    box-sizing: border-box;
  }
  .title-box {
    width: 100%;
    margin: 0 auto;
    padding: 30px;
    background: url("~@/assets/images/fourm_show_title_bg.png") center no-repeat;
    background-size: cover;
    box-sizing: border-box;
    .title {
      margin-bottom: 41px;
      .tag-top {
        background-color: #ff2e12;
        font-size: 15px;
        font-weight: 400;
        border-radius: 3px;
        color: #fff;
        padding: 2px 8px;
        margin-right: 8px;
      }
      .tag-fine {
        background-color: #fc9630;
        font-size: 15px;
        font-weight: 400;
        border-radius: 3px;
        color: #fff;
        padding: 2px 5px;
        margin-right: 12px;
      }
      .title-text {
        font-size: 30px;
        font-family: PingFangSC-Medium;
        color: #20242a;
        line-height: 37px;
      }
    }
    .other {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .time {
        font-size: 16px;
        font-family: PingFangSC-Medium;
        color: #8c8c8c;
        line-height: 16px;
      }
      .set-box {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        overflow: hidden;
        line-height: 15px;
        text-align: right;
        p {
          font-size: 15px;
          color: #8c8c8c;
        }
        .zan {
          display: inline-block;
          padding-left: 16px;
          background: url("~@/assets/images/icon_fourm_zan.png") left 2px
            no-repeat;
          background-size: 11px 11px;
        }
        .comment {
          display: inline-block;
          margin-left: 30px;
          padding-left: 16px;
          background: url("~@/assets/images/icon_fourm_comment.png") left 3px
            no-repeat;
          background-size: 11px 11px;
        }
        .browse {
          display: inline-block;
          margin-left: 30px;
          padding-left: 20px;
          background: url("~@/assets/images/icon_fourm_browse.png") left 3px
            no-repeat;
          background-size: 14px 9px;
        }
      }
    }
  }
  .forum-box {
    overflow: hidden;
    width: 100%;
    margin: 20px auto 0;
    .left {
      float: left;
      width: 830px;
      overflow: hidden;
      .message-box {
        padding: 20px 24px;
        background-color: #fff;
        .message {
          overflow: hidden;
          line-height: 40px;
          & /deep/ img {
            max-width: 100%;
            cursor: zoom-in;
          }
        }
        .set-box {
          margin: 30px 0 0;
          padding: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #fff;
          .item {
            position: relative;
            top: 0;
            display: block;
            width: 36px;
            height: 36px;
            margin: 0 20px;
            border-radius: 50%;
            overflow: hidden;
            transition: top 0.3s;
            cursor: pointer;
            background-size: 100% 100%;
            background-repeat: no-repeat;
            &:hover {
              top: -5px;
            }
          }
          .icon-comment {
            background-image: url("~@/assets/images/community/comment@3x.png");
          }
          .icon-zan {
            background-image: url("~@/assets/images/community/zan@3x.png");
          }
          .icon-zan.active {
            background-image: url("~@/assets/images/community/zan-active@3x.png");
          }
          .icon-collect {
            background-image: url("~@/assets/images/community/collect@3x.png");
          }
          .icon-collect.active {
            background-image: url("~@/assets/images/community/collect-active@3x.png");
          }
        }
      }
      .comment-box {
        margin-top: 20px;
        padding: 0 24px 30px;
        background-color: #fff;
        overflow: hidden;
        .comment-title {
          height: 50px;
          line-height: 60px;
          font-size: 16px;
          font-family: PingFangSC-Medium;
          color: #333;
          span {
            position: relative;
            display: inline-block;
            height: 45px;
          }
        }
        .comment {
          margin-top: 20px;
          overflow: hidden;
          box-sizing: border-box;
          img {
            float: left;
            display: block;
            width: 46px;
            height: 46px;
            border-radius: 50%;
          }
          .content {
            display: flex;
            justify-content: flex-end;
            align-items: flex-end;
            flex-direction: column;
            width: auto;
            margin-left: 66px;
            textarea {
              width: 100%;
              padding: 10px 15px;
              border-radius: 10px;
              border: 1px solid #8c8c8c;
              font-size: 14px;
              color: rgba(0, 0, 0, 0.85);
              box-sizing: border-box;
              line-height: 24px;
              outline: none;
              resize: none;
              &::-webkit-scrollbar {
                display: none;
              }
              &::placeholder {
                color: #b7b7b7;
              }
            }
            .comment-submit {
              display: block;
              margin-top: 15px;
              width: 86px;
              height: 36px;
              line-height: 36px;
              border: none;
              background-color: #f4f4f4;
              border-radius: 20px;
              text-align: center;
              font-size: 18px;
              color: #8c8c8c;
              outline: none;
              cursor: pointer;
            }
          }
        }
        ul {
          margin: 30px 0 0 0;
          padding: 0;
          border-top: 1px solid #e8e8e8;
          li {
            position: relative;
            padding: 20px 0;
            overflow: hidden;
            border-bottom: 1px solid #e8e8e8;
            .user {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              img {
                display: block;
                width: 20px;
                height: 20px;
                border-radius: 50%;
              }
              .nick {
                margin-left: 10px;
                font-size: 16px;
                color: #595959;
              }
            }
            .message {
              margin: 10px 0;
              line-height: 25px;
              font-size: 14px;
              color: rgba(0, 0, 0, 0.65);
              .name {
                color: $primary-color;
              }
            }
            .operate-wrap {
              display: flex;
              align-items: center;
              justify-content: space-between;

              .operate {
                font-size: 13px;
                color: #595959;

                a {
                  cursor: pointer;
                }

                .lnk-complaint {
                  display: none;
                  &:hover {
                    color: $primary-color;
                  }
                }

                .lnk-delete {
                  display: none;
                  &:hover {
                    color: #e74d3d;
                  }
                }

                .line {
                  margin: 0 4px;
                  color: #e8e8e8;
                  display: none;
                }
              }
            }
            &:hover {
              .operate-wrap {
                .operate {
                  .lnk-complaint,
                  .lnk-delete,
                  .line {
                    display: inline;
                  }
                }
              }
            }
            .time {
              font-size: 14px;
              color: rgba(0, 0, 0, 0.25);
            }
            .reply-content {
              display: flex;
              align-items: center;
              margin-top: 20px;

              textarea {
                height: 42px;
                width: 100%;
                padding: 10px 15px;
                border-radius: 3px;
                border: 1px solid #bfbfbf;
                font-size: 14px;
                color: rgba(0, 0, 0, 0.85);
                box-sizing: border-box;
                line-height: 20px;
                outline: none;
                resize: none;
                margin-right: 17px;
                &::-webkit-scrollbar {
                  display: none;
                }
                &::placeholder {
                  color: #b7b7b7;
                }
              }
              .comment-submit {
                display: block;
                width: 86px;
                height: 36px;
                line-height: 36px;
                border: none;
                background-color: $primary-color;
                border-radius: 20px;
                text-align: center;
                font-size: 18px;
                color: white;
                outline: none;
                cursor: pointer;
              }
            }
            .reply-btn {
              position: absolute;
              right: 0;
              top: 12px;
              width: 40px;
              height: 40px;
              background: url("~@/assets/images/icon_fourm_show_reply.png")
                center no-repeat;
              background-size: 14px 13px;
              cursor: pointer;
            }
            &:hover .reply-btn {
              background: url("~@/assets/images/icon_fourm_show_reply_active.png")
                center no-repeat;
              background-size: 14px 13px;
            }
          }
        }
      }
    }
    .right {
      margin-left: 860px;
      width: auto;
      .mine {
        padding: 0 20px;
        background-color: #fff;
        border-radius: 5px;
        .title {
          position: relative;
          padding: 0 20px;
          height: 50px;
          border-bottom: 1px solid #edf1f2;
          font-size: 16px;
          font-family: PingFangSC-Medium;
          color: #5b6066;
          line-height: 50px;
          cursor: pointer;
          i {
            position: absolute;
            top: 20px;
            right: 0;
            display: block;
            width: 6px;
            height: 11px;
            background: url("~@/assets/images/icon_fourm_right_arrow.png")
              center no-repeat;
            background-size: 100% 100%;
          }
        }
        .no-login {
          display: block;
          height: 220px;
          background: url("~@/assets/images/fourm_no_login_bg.png") center
            no-repeat #fff;
          background-size: 200px 100px;
          line-height: 320px;
          text-align: center;
          font-size: 17px;
          color: #20242a;
        }
        .list {
          a {
            display: block;
            margin: 20px 0;
            line-height: 14px;
            font-size: 14px;
            color: #333;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .m-recommend {
        overflow: hidden;
        .title {
          background: url("~@/assets/images/icon_fourm_title_post.png") left
            center no-repeat;
          background-size: 15px 14px;
        }
      }
    }
  }
}
</style>
